import EditorialImage from 'components/EditorialImage';
import { contentApiUrl } from 'services/client/editorial';
import React from 'react';
import Markdoc from '@markdoc/markdoc';
import { renderTree } from 'utils/shared/editorialMarkdoc';
import NewsLetterForm from 'components/Website/NewsLetter/Form';
import {
  emailMarkdocComponents,
  linkEmailAddressesInTree,
  renderEmailAddresses,
} from 'components/EmailLink/richText';

interface Props {
  body: string;
  baseUrl: string;
  onImageError?: () => void;
}

export default function EditorialBody({ body, baseUrl, onImageError }: Props) {
  const tree = linkEmailAddressesInTree(renderTree(body));
  return (
    <>
      {Markdoc.renderers.react(tree, React, {
        components: {
          ContentImage: ({ src, ...props }: any) => (
            <EditorialImage
              {...props}
              onError={onImageError}
              src={
                src.startsWith('/api/content/media?')
                  ? contentApiUrl(src.slice('/api/content/'.length))
                  : new URL(src, baseUrl).toString()
              }
            />
          ),
          ContentTable: ({ rows }: { rows: string }) => (
            <table>
              <tbody>
                {(JSON.parse(rows) as string[][]).map((row, index) => (
                  <tr key={index}>
                    {row.map((cell, column) =>
                      index === 0 ? (
                        <th key={column}>{renderEmailAddresses(cell)}</th>
                      ) : (
                        <td key={column}>{renderEmailAddresses(cell)}</td>
                      ),
                    )}
                  </tr>
                ))}
              </tbody>
            </table>
          ),
          NewsletterCta: () => <NewsLetterForm />,
          ...emailMarkdocComponents,
        },
      })}
    </>
  );
}
